module.exports = __webpack_public_path__ + "img/img30.c40a7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img30.jpg
// module id = 297
// module chunks = 0